import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { TransformedPermission } from '../../../../../app/type_interface/SettingType'
import {
  MainRouteType, SubRouteType, mainRoutesConfig, subRoutesConfig,
  RouteType
} from '../../../../../app/modules/auth/AuthMenu'
import React, { useState, useEffect } from 'react'
import { getRolePermission } from '../../../../../app/services/settingServices'
import { getEmpId, getRoleId } from '../../../../../app/helpers/appHelpers'
import { getUserAction } from '../../../../../app/helpers/pageAccess'
import { useMasterData } from '../../../../../app/context/MasterDataContext'
import { useAlertModal } from '../../../../../app/context/ModalContext'

const SidebarMenuMain = () => {

  const { masterData, setPermissionList, setActionList } = useMasterData();
  const { openAlertModal } = useAlertModal();
  const [isMenuLoading, setIsMenuLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const { permissionList } = masterData;

  //PERMISSION TEMPLATE
  const [dashboardPermission, setDashboardPermission] = useState<TransformedPermission>();
  const [currentMapPermission, setCurrentMapPermission] = useState<TransformedPermission>()
  const [currentDeliveryPermission, setCurrentDeliveryPermission] = useState<TransformedPermission>()

  // const intl = useIntl()

  const fetchPermissionList = async () => {
    setIsMenuLoading(true);
    try {
      let result = await getRolePermission(getRoleId());
      if (result) {
        if (result.success) {
          // New compact format: ['ROLE_MANAGEMENT.view', 'ROLE_MANAGEMENT.edit', ...]
          // Only granted permissions are present; absence means false.
          const permArray = result.data as string[];

          // Build map: { MODULE_CODE: ['view', 'edit', ...] }
          const permMap: Record<string, string[]> = {};
          for (const entry of permArray) {
            const dotIdx = entry.lastIndexOf('.');
            if (dotIdx === -1) continue;
            const code = entry.substring(0, dotIdx);
            const method = entry.substring(dotIdx + 1);
            if (!permMap[code]) permMap[code] = [];
            permMap[code].push(method);
          }

          const userMainRoute: MainRouteType[] = [];
          const actionList: RouteType[] = [];

          for (const mainRoute of mainRoutesConfig) {
            const subMenus: SubRouteType[] = subRoutesConfig
              .filter(sub => sub.main_module_code === mainRoute.module_code
                && (permMap[sub.module_code]?.length ?? 0) > 0)
              .map(sub => ({ ...sub, permission: permMap[sub.module_code] }));

            if (subMenus.length > 0) {
              actionList.push(...subMenus);
              userMainRoute.push({ ...mainRoute, subMenu: subMenus });
            }
          }

          setPermissionList(userMainRoute);
          setActionList(actionList);

          // Dedicated top-level items (outside the grouped "Menu" section)
          setDashboardPermission(getUserAction(actionList, "DASHBOARD", "DASHBOARD_MAIN"));
        }
      } else {
        setIsError(true);
        throw new Error("getRolePermission returns error.");
      }
    } catch (e) {
      console.error(e);
      console.log("fetchPermissionList returns error.");
    } finally {
      setIsMenuLoading(false);
    }
  }

  useEffect(() => {
    fetchPermissionList();
  }, [masterData.updatePermission])

  // ------------------------ อย่าเพิ่ม PATH ตรงนี้ หรือถ้าเพิ่มเพื่อเทส icon อย่าลืมลบก่อน PUSH ด้วยนะครับบบบบบ ------------------------
  // ------------------------------------------------ จาก DEV ผู้อดหลับอดนอน -----------------------------------------------

  return (
    <>
      {
        isMenuLoading ?

          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Loading....</span>
            </div>
          </div>
          : isError ?
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'>An error occurs while loading.</span>
              </div>
            </div>
            :
            <React.Fragment>
              {dashboardPermission?.view &&
                // <SidebarMenuItem to='/dashboard' icon='element-11' title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} fontIcon='bi-app-indicator' />
                <SidebarMenuItem to='/dashboard' icon='element-11' title={"Dashboard"} fontIcon='bi-app-indicator' />
              }
              {currentMapPermission?.view &&
                <SidebarMenuItem to='/current_map' icon='eye' title={"ติดตามรถ"} fontIcon='bi-app-indicator' />
              }
              {currentDeliveryPermission?.view &&
                <SidebarMenuItem to='/dashboard_delivery_location' icon='map' title={"ติตตามการจัดส่ง"} fontIcon='bi-app-indicator' />
              }
              {/* <SidebarMenuItem to='/work_plans' icon='switch' title='แผนงาน' fontIcon='bi-layers' /> */}

              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Menu</span>
                </div>
              </div>

              {
                // DASHBOARD is rendered as the dedicated item above, not as a group
                permissionList.filter((menu) => menu.module_code !== "DASHBOARD").map((menu, index) => {
                  return (
                    <SidebarMenuItemWithSub
                      key={`${menu.title}-${index}`}
                      to={menu.path}
                      title={menu.title}
                      fontIcon={menu.fontIcon}
                      icon={menu.icon}
                      customIcon={menu.customIcon}
                      subPaths={menu.subMenu.map((s) => s.path)}>
                      {
                        menu.subMenu.map((sub_menu, s_index) => {
                          return (
                            sub_menu.display && <SidebarMenuItem
                              key={`${sub_menu.title}-${s_index}`}
                              to={sub_menu.path}
                              title={sub_menu.title}
                              hasBullet={true} />
                          );
                        })
                      }
                    </SidebarMenuItemWithSub>
                  );
                })
              }
            </React.Fragment>
      }
    </>
  )
}

export { SidebarMenuMain }